import { classNames } from 'utils/classNames'

type ButtonType = {
  label: string
  color?: string
  clickHandler?: () => void
  disabled?: boolean
  type?: 'button'
}
export const Button = (props: ButtonType): JSX.Element => {
  const { label, color, clickHandler, disabled, type = 'submit' } = props
  const baseStyle = 'w-full h-full text-lg rounded whitespace-no-wrap'
  const colorClass = color || 'bg-[#4D968D] hover:brightness-110'
  return (
    <button
      type={type}
      className={classNames([
        baseStyle,
        'text-white',
        disabled ? 'bg-[#bebebe] text-[#5a5a5a]' : colorClass
      ])}
      onClick={clickHandler}
      disabled={disabled}
    >
      {label}
    </button>
  )
}
